import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../../common/store/types';
import { WorkLocationModel } from './types';
import { workLocationActions } from './work-location.actions';

export interface IWorkLocationState extends IState<WorkLocationModel> {
  getById: GenericState<WorkLocationModel>;
  createInstance: GenericState<WorkLocationModel>;
  add: GenericState<WorkLocationModel>;
  update: GenericState<WorkLocationModel>;
  delete: GenericState<boolean>;
}

export const workLocationInitialState: IWorkLocationState = {
  getById: new GenericState<WorkLocationModel>(),
  createInstance: new GenericState<WorkLocationModel>(),
  add: new GenericState<WorkLocationModel>(),
  update: new GenericState<WorkLocationModel>(),
  delete: new GenericState<boolean>(),
};

const workLocationReducers = [
  ...onApiCall<WorkLocationModel>(workLocationActions.getById, 'getById'),
  ...onApiCall<WorkLocationModel>(
    workLocationActions.createInstance,
    'createInstance',
  ),
  ...onApiCall<WorkLocationModel>(workLocationActions.add, 'add'),
  ...onApiCall<WorkLocationModel>(workLocationActions.update, 'update'),
  ...onApiCall<boolean>(workLocationActions.delete, 'delete'),
];

export const workLocationReducer = createReducer(
  workLocationInitialState,
  ...workLocationReducers,
) as ActionReducer<IWorkLocationState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return workLocationReducer(state, action);
}
